// MSMEStrategicGamesHome.jsx
import React, { useState } from 'react';
import NumberChakra from './NumberChakra';
import TulnaGrid from './TulnaGrid';
import RekhaLoop from './RekhaLoop';

const categories = [
  { id: 1, title: 'Number Chakra', desc: 'A powerful logic-based 9×9 grid puzzle that sharpens strategic foresight.', component: <NumberChakra /> },
  { id: 2, title: 'Tulna Grid', desc: 'A comparison-based logic puzzle that trains inequality and judgment skills.', component: <TulnaGrid /> },
  { id: 3, title: 'Rekha-Loop', desc: 'Create a single continuous loop using logical deduction. Pure strategic clarity.', component: <RekhaLoop /> },
];

export default function MSMEStrategicGamesHome() {
  const [activeGame, setActiveGame] = useState(null);

  if (activeGame) {
    return (
      <div className="p-5 bg-black min-h-screen text-gray-300">
        {activeGame.component}
      </div>
    );
  }

  return (
    <div className="bg-black min-h-screen p-5 flex flex-col items-center text-gray-300">
      <h1 className="text-2xl font-bold mb-4 text-gray-300">
        🧠 Strategic Thinking Games — Mind-of-a-CEO Series
      </h1>

      <div className="grid gap-4 w-full max-w-5xl sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        {categories.map(cat => (
          <div
            key={cat.id}
            className="flex flex-col justify-between bg-gray-900 rounded-xl p-4 shadow-md hover:shadow-lg transition"
          >
            <h3 className="text-lg font-semibold text-gray-100 mb-2">{cat.title}</h3>
            <p className="text-sm text-gray-400 flex-grow mb-4">{cat.desc}</p>

            <button
              onClick={() => setActiveGame(cat)}
              className="mt-auto px-4 py-2 rounded-lg bg-green-600 text-black font-semibold hover:bg-green-500 transition"
            >
              ▶ Play
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
